import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeaturesRoutingModule } from './features-routing.module';
import { HeaderComponent } from './header/header/header.component';
import { MenubarComponent } from './menubar/menubar/menubar.component';
import { LayoutComponent } from './layout/layout.component';
import { AppRoutingModule } from '../app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProviderORinsuranceModule } from './provider_insurance/provider-orinsurance.module';
import { SharedModule } from '../shared/shared.module';
import { PrescriptionModule } from './prescription/prescription.module';
import { RuleConfigManageModule } from './rule-config-manage/rule-config-manage.module';
import { AuthorizationModule } from './authorization/authorization.module';
import { SettingsManagementModule } from './settings-management/settings-management.module';
import { MasterManagementModule } from './master-management/master-management.module';
import { RoleManagementModule } from './role-management/role-management.module';


@NgModule({
  declarations: [
    HeaderComponent,
    MenubarComponent,
    LayoutComponent,
  ],
  imports: [
    CommonModule,
    FeaturesRoutingModule,
    AppRoutingModule,
    FormsModule,
		ReactiveFormsModule,
    ProviderORinsuranceModule,
    SharedModule,
    PrescriptionModule,
    RuleConfigManageModule,
    AuthorizationModule,
    SettingsManagementModule,
    MasterManagementModule,
    RoleManagementModule
  ],
  exports:[
  ]
})
export class FeaturesModule { }
